export const maxResults = '5';
